import { atomWithStorage } from 'jotai/utils';
export const novelChatSettingsAtom = atomWithStorage('novel_chat_settings', {
    language: 'zh-CN',
    writingStyle: 'immersive',
    person: 'second',
    plotSpeed: 'normal',
    bannedWords: '',
    fontSize: 16,
    // 默认人设名字
    myName: 'user',
    myPersona: '',
    customStyleEnabled: false,
    customStyleText: '',
});
